import { injectIntl } from "react-intl";
import { useEffect, useState } from "react";
import Header from "./Header";
import NewList from "./NewList";
import apiService from "src/services/api.service";
import { ListType, PageEnum } from "src/helpers/Enums";
import DeleteList from "../DeleteList";
import Empty from "src/components/Empty";
import SearchLine from "src/components/SearchLine";
import SMSListTable from "./SMSListTable";

const SMSList = () => {
  const [isNewListOpen, setIsNewListOpen] = useState(false);
  const [isUpdate, setIsUpdate] = useState(true);
  const [smsList, setSmsList] = useState([]);
  const [filteredSmsList, setFilteredSmsList] = useState([]);
  const [search, setSearch] = useState("");
  const [operationType, setOperationType] = useState();
  const [chosenList, setChosenList] = useState();
  const [isDeleteListOpen, setIsDeleteListOpen] = useState(false);
  const [listType, setListType] = useState();

  useEffect(() => {
    if (isUpdate) {
      apiService.getAllLists().then((response) => {
        setSmsList(response.data?.filter((item) => item.type === ListType.SMS));
      });
      setIsUpdate(false);
    }
  }, [isUpdate]);

  useEffect(() => {
    const filtered = smsList?.filter((item) => {
      const itemName = item?.name?.toLowerCase?.() || "";
      const searchTerm = search?.toLowerCase?.() || "";
      return itemName.includes(searchTerm);
    });
    setFilteredSmsList(filtered || []);
  }, [search, smsList]);

  const handleOpenNewList = (type, list) => {
    setIsNewListOpen(true);
    setOperationType(type);
    setChosenList(list);
  };

  const closeModal = () => {
    setIsNewListOpen(false);
    setIsDeleteListOpen(false);
    setIsUpdate(true);
  };

  const handleOpenDeleteList = (type, list) => {
    setIsDeleteListOpen(true);
    setChosenList(list);
    setListType(type);
  };

  return (
    <div className={"Page"}>
      <Header
        handleOpenNewList={handleOpenNewList}
        setSearch={setSearch}
        search={search}
      ></Header>
      {search && (
        <SearchLine setSearch={setSearch} search={search}></SearchLine>
      )}
      {filteredSmsList?.length > 0 ? (
        <div className={"ListsPage"}>
          <SMSListTable
            list={filteredSmsList}
            handleOpenNewList={handleOpenNewList}
            handleOpenDeleteStrategy={handleOpenDeleteList}
          ></SMSListTable>
        </div>
      ) : (
        <Empty
          handleNew={handleOpenNewList}
          title={"No SMS List Found"}
          description={
            "Start building your lists to track their performance here."
          }
          type={"List"}
          menu={PageEnum.LISTS}
        ></Empty>
      )}
      {isNewListOpen && (
        <NewList
          setIsNewListOpen={setIsNewListOpen}
          closeModal={closeModal}
          type={operationType}
          list={chosenList}
        />
      )}
      {isDeleteListOpen && (
        <DeleteList id={chosenList?._id} close={closeModal} type={listType} />
      )}
    </div>
  );
};

export default injectIntl(SMSList);
